import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import * as careUsersRedux from '../../../redux/appointmentForm/requests/care-users-req';
import * as schedulingTree from '../../../redux/appointmentForm/requests/schedulable-tree-req';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import { actions as insurancePayersActions } from '../../../redux/appointmentForm/requests/insurance-payers-req';
import { loggedUserSelector } from '../../../redux/context/selectors';
import {
  selectCareUsersList,
  selectCareUsersPending,
} from '../../../redux/appointmentForm/selectors';
import { selectAppointmentSchedulingForSelfAllowed } from '../../../redux/data/selectors';
import { dependentFormActions } from '../../../redux/dependentForm/progress.actions';

const mapStateToProps = state => ({
  loading: selectCareUsersPending(state),
  careUsers: selectCareUsersList(state),
  currentUser: loggedUserSelector(state),
  currentUserAppointmentSchedulingForSelfAllowed: selectAppointmentSchedulingForSelfAllowed(
    state,
  ),
});

const mapDispatchToProps = {
  careUsersReq: careUsersRedux.actions.send,
  setCareUser: appointmentProgressActions.setCareUser,
  fetchSchedulingTree: schedulingTree.actions.init,
  clearHealthPlans: insurancePayersActions.clear,
  clearProgress: appointmentProgressActions.clear,
  finishValidate: appointmentProgressActions.finishValidate,
  setDependentSubmitRedirect: dependentFormActions.setSubmitRedirect,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      currentUser,
      careUsersReq,
      careUsers,
      currentUserAppointmentSchedulingForSelfAllowed,
    }) => ({
      fetchCareUsers: () => careUsersReq({ id: currentUser.id }),
      users: [
        formatToDependent(
          currentUser,
          currentUserAppointmentSchedulingForSelfAllowed,
        ),
        ...filterDependents(careUsers),
      ],
    }),
  ),
);

function formatToDependent(
  user = {},
  currentUserAppointmentSchedulingForSelfAllowed = false,
) {
  return {
    id: user.id,
    user: { ...user },
    metadata: {
      isMe: true,
      appointmentSchedulingAllowed: currentUserAppointmentSchedulingForSelfAllowed,
    },
  };
}

function filterDependents(list) {
  return list.filter(({ metadata }) => {
    if (metadata.status === 'pending') {
      return metadata.careUserCreator;
    }
    return true;
  });
}



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentUsers/enhance.js